import { WebPage } from "~/components/layout/WebPage";
import { QENDO_LINKS } from "~/constants/environment";

export default function Pain() {
    return <WebPage title="Pain" uri={QENDO_LINKS.pain} />;
}
